import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { apiFetch } from '../lib/api';

export default function Vendors() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [vendors, setVendors] = useState([]);
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);
  const canManage = user && (user.role === 'admin' || user.role === 'manager');

  async function load() {
    const res = await apiFetch('/api/vendors');
    if (res.ok) { const d = await res.json(); setVendors(d.vendors); }
  }
  useEffect(() => { load(); }, []);

  async function refresh() {
    setMsg(''); setBusy(true);
    try {
      const res = await apiFetch('/api/vendors/refresh', { method: 'POST' });
      const d = await res.json().catch(() => ({}));
      if (res.ok) { setMsg(`Synced ${d.synced} from Zoho.`); load(); }
      else if (res.status === 503) setMsg('Zoho is not configured yet.');
      else if (res.status === 502) setMsg('Could not reach Zoho — cache unchanged.');
      else setMsg(d.error || 'Refresh failed.');
    } catch (e) {
      setMsg('Could not reach the server.');
    } finally { setBusy(false); }
  }

  function fmtMoney(n, cur) {
    if (n == null) return '—';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur || 'USD' }).format(n); }
    catch { return String(n); }
  }

  return (
    <div className="hq-page-content">
      <div className="hq-page-head">
        <h1>Vendors</h1>
        <p>Synced from Zoho Books. Local edits are preserved across syncs.</p>
      </div>

      <div className="hq-panel">
        <div className="hq-panel-head">
          <h2>All vendors</h2>
          {canManage && (
            <button className="hq-btn" onClick={refresh} disabled={busy}>
              {busy ? 'Syncing…' : 'Refresh from Zoho'}
            </button>
          )}
        </div>
        {msg && <p className="hq-msg" style={{ margin: '14px 20px 0' }}>{msg}</p>}
        <table className="hq-table">
          <thead>
            <tr><th>Name</th><th>Email</th><th>Status</th><th>Outstanding</th><th>Source</th></tr>
          </thead>
          <tbody>
            {vendors.map((v) => (
              <tr key={v.id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/vendors/${v.id}`)}>
                <td>{v.name || v.company_name || '—'}</td>
                <td>{v.email || '—'}</td>
                <td>
                  <span className={`hq-pill ${v.status === 'active' ? 'hq-on' : 'hq-off'}`}>
                    {v.status || 'unknown'}
                  </span>
                </td>
                <td>{fmtMoney(v.outstanding, v.currency_code)}</td>
                <td className="hq-role">{v.locally_overridden ? 'local edit' : v.source}</td>
              </tr>
            ))}
            {vendors.length === 0 && (
              <tr><td className="hq-empty" colSpan={5}>No vendors yet. Use “Refresh from Zoho”.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
